var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Apple_icon",
    "data-name": "Apple icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.716,
    height: 21.775,
    viewBox: "0 0 17.716 21.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M14.8,11.58a4.949,4.949,0,0,1,2.357-4.152A5.067,5.067,0,0,0,13.162,5.27C11.483,5.094,9.855,6.275,9,6.275c-.872,0-2.189-.987-3.608-.958A5.314,5.314,0,0,0,.918,8.045c-1.934,3.348-.491,8.269,1.361,10.976.927,1.325,2.01,2.806,3.428,2.753,1.387-.057,1.905-.884,3.579-.884,1.659,0,2.145.884,3.591.851,1.489-.024,2.426-1.331,3.321-2.669a10.964,10.964,0,0,0,1.518-3.093,4.781,4.781,0,0,1-2.919-4.4",
    transform: "translate(0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M12.066,3.491A4.874,4.874,0,0,0,13.181,0,4.96,4.96,0,0,0,9.973,1.66,4.637,4.637,0,0,0,8.829,5.021a4.1,4.1,0,0,0,3.237-1.53",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleSmall);
export default __webpack_public_path__ + "static/media/apple-small.dcefa44a42caadc5639dd593842a32fd.svg";
export { ForwardRef as ReactComponent };